// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"c7548bbf","453":"6e3d90b8"}[chunkId] + ".chunk.js";
};